import {
	ContractFilterInput,
	StudentAcademicTermEnrollmentUtilities,
	StudentFilterInput,
} from "@hex-insights/verita-romania.shared";

export function getReEnrollmentStudentFilter(): StudentFilterInput {
	return {
		studentAcademicTermEnrollments: [StudentAcademicTermEnrollmentUtilities.getEnrolledOnDateFilter()],
		studentEnrollmentIntents: [
			{
				academicYear: [
					{
						nameEQ: "2024-2025", // TODO dynamic year selection
					},
				],
				isEnrollingEQ: true,
			},
		],
		relationships: [
			{
				guardian: [
					{
						person: [
							{
								user: [
									{
										isCurrentEQ: true,
									},
								],
							},
						],
					},
				],
			},
		],
		contracts: [getReEnrollmentContractInStudentFilter()],
	};
}

export function getReEnrollmentContractFilter(): ContractFilterInput {
	return {
		student: [getReEnrollmentStudentFilter()],
		academicTerms: [
			{
				nameEQ: "Autumn 2024", // TODO dynamic term selection
			},
		],
	};
}

export function getReEnrollmentContractInStudentFilter(): ContractFilterInput {
	return {
		academicTerms: [
			{
				nameEQ: "Autumn 2024", // TODO dynamic term selection
			},
		],
	};
}
